(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-cariboo-shipping-calculator]').forEach((block) => {
      if (block.dataset.shippingCalculatorInitialized) return;
      block.dataset.shippingCalculatorInitialized = 'true';

      const update = () => {
        const calculator = block.querySelector('.js--calculator-product-container');
        const opener = calculator?.querySelector('.oct-calculator-open');
        const panel = calculator?.querySelector(':scope > .oct-calculator-form-container');
        if (!opener || !panel) return;

        const label = block.dataset.shippingCalculatorLabel;
        if (label && opener.textContent !== label) opener.textContent = label;
        opener.setAttribute('role', 'button');
        panel.id = panel.id || `${block.dataset.caribooShippingCalculator}-form`;
        opener.setAttribute('aria-controls', panel.id);
        opener.setAttribute('aria-expanded', String(panel.childElementCount > 0));
      };

      block.addEventListener('click', (event) => {
        if (event.target.closest('.oct-calculator-open')) event.preventDefault();
      });
      block.addEventListener('keydown', (event) => {
        if (event.key === ' ' && event.target.matches('.oct-calculator-open')) {
          event.preventDefault();
        }
      });
      block.addEventListener('keyup', (event) => {
        if (event.key === ' ' && event.target.matches('.oct-calculator-open')) {
          event.preventDefault();
          event.target.click();
        }
      });

      const observer = new MutationObserver(update);
      observer.observe(block, { childList: true, subtree: true });
      block.shippingCalculatorObserver = observer;
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cariboo-shipping-calculator]').forEach((block) => {
      block.shippingCalculatorObserver?.disconnect();
    });
  });
})();
